// extracted by mini-css-extract-plugin
module.exports = {"News":"News_News__99DNW","Title":"News_Title__ehW4V","Project":"News_Project__2mPsU","ProjectBold":"News_ProjectBold__B7KZQ","listStyle":"News_listStyle__2GOk0"};